import * as React from 'react';
import { observer } from 'mobx-react';
import { Page, Pane, PaneBody, PaneHeader } from '../../components/atoms/applications/page';
import './withdrawalCompletePage.module.scss';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../routes';
import { NavigationSpecs } from '../../states/NavigationState';
import { withNavigation } from '../../components/hocs/withNavigation';
import moment from 'moment-timezone';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { WithdrawalDateTime } from '../../components/atoms/withdrawals/WithdrawalDateTime';

@withNavigation(NavigationSpecs.none())
@observer
export class WithdrawalCompletePage extends React.Component {
    async componentDidMount() {
        await GlobalStatesV3.currentUser.withdrawal.init();
    }

    render() {
        const currentUser = GlobalStatesV3.currentUser.currentUser;
        const withdrawal = GlobalStatesV3.currentUser.withdrawal;
        const loading = withdrawal.loading;
        const effectiveAt = moment(withdrawal.withdrawalEffectiveAt);
        const serviceExpiresAt = moment(effectiveAt).add(-1, 'second');
        if (loading) {
            return <LoaderRow />;
        }
        return (
            <Page styleName="page" id="withdrawal-complete-page">
                <div styleName="header">退会処理が完了しました</div>
                <PaneBody>
                    <div styleName="withdrawal_complete_body">
                        <div styleName="attention attention-confirmation">
                            <div styleName="attention_text">
                                下記のメールアドレスに退会申請の完了案内を送付いたしました。ご確認くださいませ。
                            </div>

                            <div styleName="email">{currentUser.email}</div>
                        </div>
                        <div styleName="description">
                            <div styleName="description_text">
                                <WithdrawalDateTime styleName="date" dateTime={effectiveAt} />に完全に退会処理が行われます。
                                <br />
                                それまでの期間(<WithdrawalDateTime
                                    dateTime={serviceExpiresAt}
                                />まで)はSHElikesをお使いいただけますのでぜひ最後までご活用くださいませ。
                            </div>
                        </div>
                        <Button
                            styleName="submit-button"
                            type="primary"
                            size="l"
                            onClick={() => GlobalStatesV3.routing.push(V3Routes.plan())}
                        >
                            ホームに戻る
                        </Button>
                    </div>
                </PaneBody>
            </Page>
        );
    }
}
